module.exports = __webpack_public_path__ + "img/heatmap.2b3eff42.svg";